import { render } from "./ProDisplayTemplateIndex.vue?vue&type=template&id=6a6c357a"
import script from "./ProDisplayTemplateIndex.vue?vue&type=script&lang=js"
export * from "./ProDisplayTemplateIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__